export default "__VITE_ASSET__59beccad__$_?react__"